import { render } from "./ProductsChooser.vue?vue&type=template&id=f15d4172"
import script from "./ProductsChooser.vue?vue&type=script&lang=js"
export * from "./ProductsChooser.vue?vue&type=script&lang=js"
script.render = render

export default script